import './application.js'

import 'react-datetime/css/react-datetime.css'
import 'jquery-ui/ui/widgets/sortable'
import '../javascript/jquery-dataTables'
import '../javascript/dataTables-bootstrap4'
import 'jquery-serializejson'

import '../javascript/trix_customization'
import '@rails/actiontext'

import 'moment'
import 'lodash'
// import 'jquery-ujs'
// import 'babel-polyfill'

import '../javascript/artists'
import '../javascript/markdown'

const initDatatable = () => {
  $('.datatable').not('.initialized').addClass('initialized').DataTable({
    order: [[ 1, 'asc' ]]
  })
}

$(document).on('turbolinks:load', initDatatable)

// Support component names relative to this directory:
var componentRequireContext = require.context("../components", true, /^\.\/[^~]*$/)
var ReactRailsUJS = require("react_ujs")
ReactRailsUJS.useContext(componentRequireContext)

